import React, { Component } from "react";
import {
  Form,
  FormGroup,
  FormControl,
  Button,
  Col,
  Row
} from "react-bootstrap";
import { toastr } from "react-redux-toastr";

// utils
import { create } from "../../../utils/apiService";

class UsersForm extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      name: "",
      email: ""
    };

    this.submitForm = this.submitForm.bind(this);
    this.getNameValidationState = this.getNameValidationState.bind(this);
    this.getEmailValidationState = this.getEmailValidationState.bind(this);
  }
  getNameValidationState() {
    const length = this.state.name.length;
    if (length > 1) return "success";
    else if (length > 0) return "error";
    return null;
  }
  getEmailValidationState() {
    const email = this.state.email;
    if (email.length === 0) return;
    /*eslint-disable */
    if (
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      return "success";
    } else {
      return "error";
    }
    /*eslint-enable */
  }
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  submitForm(e) {
    e.preventDefault();
    let nameValidationState = this.getNameValidationState();
    let emailValidationState = this.getEmailValidationState();

    if (nameValidationState === "error" || emailValidationState === "error") {
      return;
    }

    if (this.state.name === "" || this.state.email === "") {
      this.setState({
        error: "Nome e e-mail não podem ser vazios."
      });
      return;
    }

    this.setState({
      error: ""
    });

    let url = "/users";
    let data = {
      user: {
        name: this.state.name,
        email: this.state.email
      }
    };

    toastr.info("Criando usuário...");
    create(url, data)
      .then(res => {
        toastr.success("Usuário criado com sucesso!");
        this.setState({
          name: "",
          email: ""
        });
      })
      .catch(err => {
        toastr.error("Erro ao criar usuário...");
      });
  }
  render() {
    return (
      <div className="users-form">
        <h2>Criar novo usuário</h2>
        <Form onSubmit={this.submitForm}>
          <Row>
            <Col md={5}>
              <FormGroup
                controlId="formBasicText"
                validationState={this.getNameValidationState()}
              >
                <FormControl
                  type="text"
                  name="name"
                  value={this.state.name}
                  placeholder="Digite o nome que será criado"
                  onChange={this.handleChange}
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
            <Col md={5}>
              <FormGroup
                controlId="formBasicText"
                validationState={this.getEmailValidationState()}
              >
                <FormControl
                  type="text"
                  name="email"
                  value={this.state.email}
                  placeholder="Digite o e-mail que será criado"
                  onChange={this.handleChange}
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Button type="submit">Criar usuário</Button>
            </Col>
            <Col md={12}>
              <small className="text-danger">{this.state.error}</small>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default UsersForm;



// WEBPACK FOOTER //
// ./src/components/pages/Users/UsersForm.js